import React, { useCallback, useMemo } from "react";
import {
    ToastsActions,
    TToastPosition,
    useToasterDispatch,
    useToasterSelector,
} from "userful-chronos-common-store/dist/toasts";

import AppToast from "./toast/AppToast";

import "./AppToasts.scss";

export default function AppToasts() {
    const dispatch = useToasterDispatch();
    const config = useToasterSelector((state) => state.main.config);
    const toasts = useToasterSelector((state) => state.main.toasts);

    const limitedToasts = useMemo(() => {
        const maxVisible = Math.max(1, config.maxVisible);
        return toasts.slice(0, maxVisible);
    }, [config.maxVisible, toasts]);

    const handleRemove = useCallback(
        (id: string): void => {
            dispatch(ToastsActions.removeFromQueue(id));
        },
        [dispatch],
    );

    if (limitedToasts.length === 0) {
        return null;
    }

    const containerClass = `userful-toasts userful-toasts--${positionClassMap[config.position] ?? config.position}`;

    return (
        <div className={containerClass} role="status" aria-live="polite">
            {limitedToasts.map((toast) => (
                <AppToast key={toast.id} toast={toast} onRemove={handleRemove} />
            ))}
        </div>
    );
}

const positionClassMap: Record<TToastPosition, string> = {
    "top-left": "top-left",
    "top-left-corner": "top-left",
    "top-center": "top-center",
    "top-right": "top-right",
    "top-right-corner": "top-right",
    "bottom-left": "bottom-left",
    "bottom-left-corner": "bottom-left",
    "bottom-center": "bottom-center",
    "bottom-right": "bottom-right",
    "bottom-right-corner": "bottom-right",
};
